<div class="nms-pagination">
  <div class="nms-pagination__size">
    <span class="nms-pagination__label">{{ showLabel() }}</span>
    <mat-form-field class="nms-pagination__select-field" appearance="outline" subscriptSizing="dynamic">
      <mat-select
        [value]="pageSize()"
        [attr.data-cy]="section() + '-page-size-' + position()"
        (selectionChange)="changePageSize($event.value)">
        @for (size of pageSizeOptions(); track size) {
          <mat-option [value]="size">{{ size }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <span class="nms-pagination__suffix">{{ perPageLabel() }}</span>
  </div>

  <div class="nms-pagination__pages">
    <button
      mat-button
      type="button"
      class="nms-pagination__nav"
      [attr.data-cy]="section() + '-prev-page-' + position()"
      [disabled]="pageIndex() === 0"
      (click)="goToPage(pageIndex() - 1)">
      ‹
    </button>

    @for (page of pageNumbers(); track page) {
      <button
        mat-button
        type="button"
        class="nms-pagination__page"
        [class.nms-pagination__page--active]="pageIndex() + 1 === page"
        [attr.data-cy]="section() + '-page-' + position() + '-' + page"
        (click)="goToPage(page - 1)">
        {{ page }}
      </button>
    }

    <button
      mat-button
      type="button"
      class="nms-pagination__nav"
      [attr.data-cy]="section() + '-next-page-' + position()"
      [disabled]="pageIndex() >= totalPages() - 1"
      (click)="goToPage(pageIndex() + 1)">
      ›
    </button>
  </div>
</div>
